import { useState, useEffect } from 'react';
import axios from 'axios';
import ProductCard from '../components/ProductCard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cat, setCat] = useState('all');
  const cats = ['all', 'Superfoods', 'Premium', 'Raw Honey', 'Supplements'];

  useEffect(() => {
    axios.get(`${API}/products`).then(r => { setProducts(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const filtered = products.filter(p => cat === 'all' || p.category === cat);

  return (
    <div className="min-h-screen pt-24" data-testid="products-page">
      <section className="py-16 text-center">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <p className="t-label c-gold mb-4">The Collection</p>
          <h1 className="t-headline text-5xl md:text-6xl c-cream mb-4">Premium Bee Products</h1>
          <div className="gold-line mx-auto mb-6" />
          <p className="t-body c-muted max-w-xl mx-auto">
            Each product is meticulously sourced from California and Arizona's finest apiaries — pure, potent, and crafted by nature.
          </p>
        </div>
      </section>

      <section className="pb-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-wrap justify-center gap-6">
          {cats.map(c => (
            <button key={c} onClick={() => setCat(c)}
              className={`t-label text-[11px] pb-2 border-b transition-all ${cat === c ? 'c-cream border-bb-gold' : 'c-muted border-transparent hover:c-cream'}`}
              data-testid={`filter-${c.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {c === 'all' ? 'All' : c}
            </button>
          ))}
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          {loading ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">{[1,2,3,4,5].map(i => <div key={i} className="bg-bb-rich aspect-[3/4] animate-pulse" />)}</div>
          ) : filtered.length === 0 ? (
            <div className="text-center py-20">
              <p className="font-heading text-2xl c-cream mb-4">No products found</p>
              <p className="t-body c-muted">Try selecting a different category.</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map(p => <ProductCard key={p.id} product={p} />)}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default ProductsPage;
